export enum CommonErrorMessages {
  DefaultError = 'Something went wrong. Please try again later.',
  RequiredField = 'This field is required',
}

export enum CommonButtonLabelMessages {
  ContinueButtonLabel = 'Continue',
  CancelButtonLabel = 'Cancel',
}
